import { apiSlice } from "../../app/api/apiSlice";


export const couponApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllCoupons: builder.query({
      query: () => "/coupons",
      providesTags: ["Coupons"],
    }),
    createCoupon: builder.mutation({
      query: (body) => ({
        url: "/coupons",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Coupons"],
    }),
    deactivateCoupon: builder.mutation({
      query: (id) => ({
        url: `/coupons/${id}/deactivate`,
        method: "PUT",
      }),
      invalidatesTags: ["Coupons"],
    }),
    deleteCoupon: builder.mutation({
      query: (id) => ({
        url: `/coupons/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Coupons"],
    }),
  }),
});

export const {
  useGetAllCouponsQuery,
  useCreateCouponMutation,
  useDeactivateCouponMutation,
  useDeleteCouponMutation,
} = couponApiSlice;
